import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CardV2 as Card, Icon, showError } from '@feathr/components';
import { useSupportChat } from '@feathr/extender/hooks';
import { useUser } from '@feathr/report_components';

import * as styles from './HelpCard.css';

function HelpCard(): JSX.Element {
  const { t } = useTranslation();
  const user = useUser();
  const { openSupportChat } = useSupportChat();

  function handleOpenHelpDesk(): void {
    const link = 'https://help.feathr.co/hc/en-us';
    window.open(link, '_blank');
  }

  function handleOpenLearningResources(): void {
    const link = 'https://training.feathr.co/';
    window.open(link, '_blank');
  }

  async function handleCloseHelpCard(): Promise<void> {
    user.setSetting('show_feathr_lite_help_card', false);
    try {
      await user.patchDirty();
    } catch (error) {
      showError(error, t);
    }
  }

  return (
    <Card contentClassName={styles.card}>
      <Card.Content
        contentClassName={styles.content}
        description={t('Our team is here to help you get started with Feathr.')}
        title={t('Need help?')}
        titleClassName={styles.help}
        titleSuffix={
          <Button className={styles.closeButton} onClick={handleCloseHelpCard} type={'icon-small'}>
            <Icon icon={faTimes} />
          </Button>
        }
      >
        <Button onClick={handleOpenHelpDesk} type={'primary'}>
          {t('View Help Desk')}
        </Button>

        <Button onClick={openSupportChat} type={'secondary'}>
          {t('Contact Support')}
        </Button>

        <Button onClick={handleOpenLearningResources} type={'secondary'}>
          {t('Feathr Academy')}
        </Button>
      </Card.Content>
    </Card>
  );
}

export default HelpCard;
